{
    "name": "@reservoir0x/reservoir-sdk",
    "version": "2.5.7",
    "description": "An SDK that can be used in any javascript/typescript context to easily interact with Reservoir liquidity APIs",
    "author": "Reservoir Protocol",
    "license": "MIT",
    "exports": {
        ".": {
            "import": "./dist/index.mjs",
            "require": "./dist/index.js",
            "types": "./dist/index.d.ts"
        }
    },
    "source": "./src/index.ts",
    "main": "./dist/index.js",
    "module": "./dist/index.mjs",
    "types": "./dist/index.d.ts",
    "files": [
        "dist"
    ],
    "scripts": {
        "clean": "rm -rf dist",
        "test": "jest",
        "syncApi": "node ./sync-api.mjs"
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/reservoirprotocol/reservoir-kit"
    },
    "sideEffects": false,
    "keywords": [
        "nft",
        "reservoir",
        "reservoir-sdk",
        "reservoirkit",
        "protocol",
        "sdk"
    ],
    "dependencies": {
        "axios": "^1.6.7"
    },
    "publishConfig": {
        "access": "public"
    },
    "devDependencies": {
        "@types/jest": "^29.5.2",
        "jest": "^29.5.0",
        "openapi-typescript": "^5.4.1",
        "ts-jest": "^29.1.0"
    },
    "peerDependencies": {
        "viem": "~2.22.8"
    }
}
